import React from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

/**
 * A generic input field that does NOT depend on Formik.
 * Use this for simple state-controlled forms.
 */
const ManualInput = ({
    disable,
    required,
    label,
    value,
    onChange,
    name,
    type = "text",
    isPassword,
    showPassword,
    onPasswordToggle,
    placeholder,
    className = "",
    error,
    ...props
}) => {
    return (
        <div className="form-control w-full">
            {/* Label */}
            {label && (
                <label
                    className="block text-[10px] font-bold text-gray-500 uppercase mb-1"
                >
                    {label}
                    {required && <span className="text-red-500 ml-1">*</span>}
                </label>
            )}

            {/* Regular Input Field */}
            <div className="relative">
                <input
                    name={name}
                    type={isPassword && !showPassword ? "password" : type}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    disabled={disable}
                    autoComplete="off"
                    className={`
            w-full px-4 py-2 text-sm
            border border-gray-300 rounded-lg
            focus:ring-2 focus:ring-primary/50
            focus:border-primary
            transition-all duration-200
            placeholder:text-gray-400
            ${disable ? 'bg-gray-100 cursor-not-allowed' : 'bg-white hover:border-gray-400'}
            ${error ? 'border-red-500 focus:ring-red-500/30 focus:border-red-500' : 'border-gray-300'}
            ${isPassword ? 'pr-12' : ''}
            ${className}
          `}
                    {...props}
                />

                {/* Password Toggle */}
                {isPassword && (
                    <button
                        type="button"
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none focus:text-primary transition-colors duration-200"
                        onClick={onPasswordToggle}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                    >
                        {showPassword ? (
                            <FaEyeSlash className="h-5 w-5" />
                        ) : (
                            <FaEye className="h-5 w-5" />
                        )}
                    </button>
                )}
            </div>

            {/* Error Message */}
            {error && (
                <p className="mt-1 text-sm text-red-600 flex items-center gap-1">
                    <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                    {error}
                </p>
            )}
        </div>
    );
};

export default ManualInput;
